import { useContext } from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';
import AppContext from '../../context/AppContext';
import { US_CONTENT } from '../../utils/geoBlock';

export default function ArticleTags(props) {
	const { article } = props;
	const { isUsTraffic } = useContext(AppContext);
	const MAXIMUM_TAGS = 5;
	const allTags = article?.tags.nodes;

	// Filter out any US tags for US visitors
	const filteredTags = (isUsTraffic) ? (
		allTags.filter((tag) => typeof tag.distributions === 'undefined' || !tag?.distributions.includes(US_CONTENT))
	) : (
		allTags
	);

	// Limit number of tags shown
	const tags = filteredTags.slice(0, MAXIMUM_TAGS);

	// Create button elements for the post tags
	const tagButtons = tags.map((tag) => (
		<li className="post-tag" key={tag.slug}>
			<Link href={`/tag/${tag.slug}/`} className="button-primary post-tag-link">
				{tag.name}
			</Link>
		</li>
	));

	return (
		tagButtons.length ? (
			<ul className="post-tags">
				{tagButtons}
			</ul>
		) : null
	);
}

ArticleTags.propTypes = {
	article: PropTypes.object.isRequired,
};
